import React, { useContext } from "react";
import Select, { components } from "react-select";
import CustomizerContext from "../../_helper/Customizer";

const SELECT_ALL_VALUE = "__select_all__";

const CheckboxOption = (optionProps) => {
  const isChecked =
    optionProps.data._isChecked !== undefined
      ? optionProps.data._isChecked
      : optionProps.isSelected;

  return (
    <components.Option {...optionProps}>
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <input
          type="checkbox"
          checked={isChecked}
          readOnly
          style={{ cursor: "pointer", accentColor: "#41CC7D" }}
        />
        <span>{optionProps.label}</span>
      </div>
    </components.Option>
  );
};

const CustomSelect = ({ options, onChange, enableCheckbox = false, ...props }) => {
  const { mix_background_layout } = useContext(CustomizerContext);

  const isMulti = props.isMulti;
  const useCheckbox = enableCheckbox && isMulti;
  const hasOptions = options && options.length > 0;
  const isAllSelected = useCheckbox && hasOptions && props.value && props.value.length === options.length;

  const displayOptions = useCheckbox && hasOptions
    ? [
        {
          label: isAllSelected ? "Deselect All" : "Select All",
          value: SELECT_ALL_VALUE,
          _isChecked: isAllSelected,
        },
        ...options,
      ]
    : options;

  const handleChange = (selected) => {
    if (useCheckbox && selected && selected.some((item) => item.value === SELECT_ALL_VALUE)) {
      onChange(isAllSelected ? [] : [...options]);
      return;
    }
    onChange(selected);
  };

  return (
    <Select
      {...props}
      closeMenuOnSelect={!isMulti}
      blurInputOnSelect={!isMulti}
      {...(useCheckbox && { hideSelectedOptions: false, components: { Option: CheckboxOption } })}
      options={displayOptions}
      onChange={handleChange}
      styles={{
        multiValueLabel: (base) => ({ ...base, color: mix_background_layout == "dark-only" ? "black" : null }),
        multiValue: (base) => ({ ...base, color: mix_background_layout == "dark-only" ? "black" : null }),
        singleValue: (base) => ({ ...base, color: mix_background_layout == "dark-only" ? "rgba(255, 255, 255, 0.7)" : null }),
        valueContainer: (base) => ({
          ...base,
          // background: colourOptions[2].color,
          //placeholder color
          width: "100%"
        }),
        control: (base, state) => ({
          ...base,
          backgroundColor: mix_background_layout == "dark-only" ? state.isDisabled ? "hsl(0, 0%, 75%)" : "#1d1e26" : null,
          borderColor: mix_background_layout == "dark-only" ? state.isFocused ? "#374558" : "#374558" : state.isFocused ? "rgb(38,132,255)" : "rgb(204, 204, 204)",
          // Removes weird border around container
          boxShadow: mix_background_layout == "dark-only" ? state.isFocused ? "0 0 0 0.25rem rgba(13, 110, 253, 0.25)" : null : state.isFocused ? "0px 0px 0px 1px rgb(38,132,255)" : null,
          "&:hover": {
            // Overwrittes the different states of border
            borderColor: mix_background_layout == "dark-only" ? state.isFocused ? "#374558" : "#374558" : state.isFocused ? "rgb(38,132,255)" : "rgb(204, 204, 204)",
            boxShadow: mix_background_layout == "dark-only" ? state.isFocused ? "0 0 0 0.25rem rgba(13, 110, 253, 0.25)" : null : state.isFocused ? "0px 0px 0px 1px rgb(38,132,255)" : null,
          }
        }),
        dropdownIndicator: base => ({
          ...base,
          "svg": {
            fill: mix_background_layout == "dark-only" ? "rgba(255, 255, 255, 0.7)" : null
          }
        }),
        menuList: (base) => ({
          ...base,
          color: mix_background_layout == "dark-only" ? "black" : null
        }),
        option: (base, state) => ({
          ...base,
          backgroundColor:
            mix_background_layout == "dark-only"
              ? state.isSelected
                ? "#e0e0e0" // dark mode selected color
                : state.isFocused
                  ? "#f0f0f0"
                  : null
              : state.isSelected
                ? "rgba(65, 204, 125, 0.15)" // light green theme match
                : state.isFocused
                  ? "#f8f9fa"
                  : null,
          color:
            mix_background_layout == "dark-only"
              ? "black"
              : state.isSelected
                ? "#2b2b2b"
                : "inherit",
          "&:active": {
            backgroundColor:
              mix_background_layout == "dark-only"
                ? "#d0d0d0"
                : "rgba(65, 204, 125, 0.25)",
          },
        }),
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
      }}
      theme={(theme) => ({
        ...theme,
        // borderRadius: 0,
        colors: mix_background_layout == "dark-only" ? {
          ...theme.colors,
          /*
           * control/backgroundColor
           * menu/backgroundColor
           * option/color(selected)
           */
          // neutral0: "black",

          neutral30: "#86b7fe", //control/borderColor(focused)
          // neutral10: "grey",
          neutral80: "white", //input color
          primary25: "#ccc", //option bg color focued
          primary: "black", //option bg color selected
          primary50: "white", // option bg color active(enavled or available)
          neutral90: "hotpink"
        } : {
          ...theme.colors
        }
      })}
    />
  );
};

export default CustomSelect;
